import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { teachingCoverageModeList } from '@/module/Travel/Request/model/TravelRequestTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type TeachingCoverageModeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function TeachingCoverageModeSelectControl<T extends FieldValues>(
  props: TeachingCoverageModeSelectControlProps<T>,
) {
  const { t } = useTranslation();
  const options = useMemo(
    () => teachingCoverageModeList.map(value => ({ value, label: t(`travel.teachingCoverageModeEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
